export default __webpack_public_path__ + "static/media/card-icon.2826ee31.svg";